import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { RouterContext } from '@/router';
import { TooltipProvider } from '@/components/ui/tooltip';

/**
 * It is important to use createRootRouteWithContext to create the root route.
 * Otherwise the router context will not be properly typed.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

/**
 * The root layout component. Auth lives above the router (in App.tsx) so it can
 * feed the router context; the sidebar shell is scoped to the `_app` group, so
 * unauthenticated routes (`_auth`) render bare here.
 */
export function RootLayout() {
  return (
    <TooltipProvider>
      <Outlet />
      <TanStackRouterDevtools position='bottom-right' initialIsOpen={false} />
    </TooltipProvider>
  );
}
